import Layout from 'layout';
import MidtermReviewFormEdit from 'features/MidtermReview/pages/Edit';
import { LayoutProvider } from '../layout/context/layoutcontext';

function MidtermReviewFormEditPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <MidtermReviewFormEdit />
      </Layout>
    </LayoutProvider>
  );
}

export default MidtermReviewFormEditPage;
